import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material'
import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { ProgramType } from '../../swagger'
import Header, { HeaderVariant } from './Header'

export const programTypes = Object.values(ProgramType).filter(
  (program) => program !== ProgramType.Scribblers
)

export const ProgramsCheckBoxSelector: React.FC<{
  handleProgramSelection?: (programs: string[]) => void
}> = (props) => {
  const { t } = useTranslation()

  const selectedPrograms = useRef<string[]>([])

  const handleProgramSelection = (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    let newSelection = [...selectedPrograms.current, event.target.name]

    if (!checked) {
      newSelection = selectedPrograms.current.filter(
        (program) => program !== event.target.name
      )
    }

    selectedPrograms.current = newSelection
    props.handleProgramSelection?.(selectedPrograms.current)
  }

  return (
    <Box>
      <Header
        id="addProgramsHeader"
        headerName={t(
          'Communities.CommunityForm.AddPrograms.Header',
          'Programs'
        )}
        component="h3"
        variant={HeaderVariant.Subheader}
      />

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: 'repeat(2, auto)', sm: 'repeat(4, auto)' },
          gridTemplateRows: 'auto auto',
        }}
      >
        {programTypes.map((programType) => {
          return (
            <FormControlLabel
              key={`${programType}CheckboxLabel`}
              control={
                <Checkbox
                  name={programType}
                  color="secondary"
                  onChange={handleProgramSelection}
                />
              }
              label={
                <Typography variant="caption" component="p">
                  {programType}
                </Typography>
              }
            />
          )
        })}
      </Box>
    </Box>
  )
}
